(() => {
  const config = JSON.parse(document.getElementById('ci-digital-config').textContent);
  const productId = '10621050618122';
  const version = 'smokey-digital-2026-10-combined-v2';
  const names = ['consent_1', 'consent_2', 'consent_version', 'consent_language', 'consent_product', 'consent_variants'];
  const courseItems = (cart) => cart.items.filter((item) => String(item.product_id) === productId);
  const quantity = (cart) => courseItems(cart).reduce((sum, item) => sum + item.quantity, 0);
  const fingerprint = (cart) => JSON.stringify(cart.items.map((item) => [item.key, item.quantity]).sort());
  let revision = 0;
  let writing = Promise.resolve();
  let adding = false;
  let checkingOut = false;
  const request = async (path, body) => {
    const response = await fetch(config.root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      cache: 'no-store',
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    if (!response.ok) throw new Error(config.error);
    return response.json();
  };
  const queue = (task) => {
    writing = writing.catch(() => {}).then(task);
    return writing;
  };
  const clearAttributes = () => queue(async () => {
    const cart = await request('cart.js');
    if (names.some((name) => cart.attributes[name])) {
      await request('cart/update.js', { attributes: Object.fromEntries(names.map((name) => [name, ''])) });
    }
  });
  const reset = () => {
    revision += 1;
    document.querySelectorAll('ci-digital-consent').forEach((box) => box.reset());
    clearAttributes().catch(() => {});
  };
  class DigitalConsent extends HTMLElement {
    connectedCallback() {
      this.inputs = [...this.querySelectorAll('[data-consent]')];
      this.error = this.querySelector('[role="alert"]');
      this.reset();
      this.addEventListener('change', () => {
        revision += 1;
        this.error.hidden = true;
        this.inputs.forEach((input) => input.removeAttribute('aria-invalid'));
        clearAttributes().catch(() => this.showError(config.error));
      });
      document.querySelectorAll(`[form="${this.dataset.form}"][data-ci-checkout]`).forEach((button) => { button.disabled = false; });
    }
    reset() {
      this.inputs.forEach((input) => { input.checked = false; input.removeAttribute('aria-invalid'); });
      this.error.hidden = true;
    }
    valid() { return this.inputs.length === 1 && this.inputs[0].dataset.consent === 'combined' && this.inputs[0].checked; }
    showError(message) {
      this.error.textContent = message;
      this.error.hidden = false;
      const missing = this.inputs.find((input) => !input.checked);
      this.inputs.forEach((input) => input.setAttribute('aria-invalid', String(!input.checked)));
      (missing || this.error).focus();
    }
  }
  customElements.define('ci-digital-consent', DigitalConsent);
  window.ciDigitalConsent = {
    async notification(element) {
      try {
        const cart = await request('cart.js');
        element.querySelector('[name="checkout"]').textContent = quantity(cart) ? config.review : config.checkout;
      } catch (error) { return; }
    },
    async beforeAdd(form) {
      const variant = String(new FormData(form).get('id'));
      if (!config.variants.includes(variant)) return true;
      if (adding) return false;
      adding = true;
      try {
        await clearAttributes();
        const cart = await request('cart.js');
        if (quantity(cart) > 0) {
          window.location.assign(config.cart);
          return false;
        }
        const input = form.elements.namedItem('quantity');
        if (input) input.value = '1';
        return true;
      } catch (error) { throw new Error(config.error); }
      finally { adding = false; }
    },
  };
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.matches('.header-language-switch') && document.querySelector('ci-digital-consent')) {
      const language = event.submitter?.value;
      const alternate = [...document.querySelectorAll('link[rel="alternate"][hreflang]')].find((link) => link.hreflang === language);
      if (alternate && new URL(alternate.href).origin === window.location.origin) {
        event.preventDefault();
        reset();
        window.location.assign(alternate.href);
        return;
      }
    }
    const checkout = event.submitter?.name === 'checkout' || form.id === 'cart-notification-form';
    if (!checkout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingOut) return;
    checkingOut = true;
    const box = document.querySelector(`ci-digital-consent[data-form="${form.id}"]`);
    const startRevision = revision;
    try {
      await writing;
      let cart = await request('cart.js');
      const count = quantity(cart);
      if (count > 0) {
        if (!box) { window.location.assign(config.cart); return; }
        if (count !== 1) { box.showError(config.quantityError); return; }
        if (!box.valid()) { box.showError(config.required); return; }
        const before = fingerprint(cart);
        const attributes = {
          consent_1: 'true', consent_2: 'true', consent_version: version,
          consent_language: config.language, consent_product: productId,
          consent_variants: [...new Set(courseItems(cart).map((item) => String(item.variant_id)))].sort().join(','),
        };
        cart = await queue(() => request('cart/update.js', { attributes }));
        if (revision !== startRevision || !box.isConnected || !box.valid() || quantity(cart) !== 1 || fingerprint(cart) !== before || names.some((name) => cart.attributes[name] !== attributes[name])) {
          await clearAttributes();
          box.showError(config.changed);
          return;
        }
      }
      const checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'checkout';
      form.append(checkoutInput);
      HTMLFormElement.prototype.submit.call(form);
      checkoutInput.remove();
    } catch (error) {
      if (box) box.showError(config.error);
      else window.location.assign(config.cart);
    } finally { checkingOut = false; }
  }, true);
  window.addEventListener('pageshow', reset);
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, reset);
})();

